<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="recheckForm" label-width="auto" label-position="right">
      <el-form-item label="上传时间：" v-if="(operateState & 2) == 2">
        {{recheckForm.recheckTime}}
      </el-form-item>
      <el-form-item label="回访截图：">
        <div>
          <el-space>
            <div class="img-box" v-for="(item, index) in imgArray.slice(0, 4)" :key="item.id" @click="showImg(index)">
              <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div class="add" v-if="imgArray.length > 0" @click="userImgList()">
              <span>全部图片</span>
            </div>
          </el-space>
          <div v-if="(operateState & 2) != 2">
            <el-button @click="fileUpdate">+ 上传图片</el-button>
            <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png,.heic"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
          </div>
        </div>
      </el-form-item>
      <el-form-item label="复核状态：" v-if="(operateState & 2) == 2">
        <el-radio-group v-model="recheckForm.recheckState">
          <el-radio :label="6">已通过</el-radio>
          <el-radio :label="4">资料驳回</el-radio>
          <el-radio :label="5">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核备注：" v-if="recheckForm.recheckState == 4">
        <el-input v-if="(operateState & 2) == 2" type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="recheckForm.recheckRemark" placeholder="请输入资料驳回备注信息" />
        <p v-else>{{recheckForm.recheckRemark}}</p>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;" v-if="(operateState & 2) == 2">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {listVisitImg, updateVisitRecheckState} from "@/api/url";
import Dialog from "@/assets/js/dialog";
import UserImgUpload from "@/components/imgList/UserImgUpload";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      recheckForm: this.value.recheckForm,
      operateState: this.value.operateState,
      imgArray: this.value.recheckForm.visitImgList?this.value.recheckForm.visitImgList:[],
    }
  },
  methods: {

    showImg(idx) {
      let imgList = []
      for(let i=0; i<this.imgArray.length; i++) {
        imgList.push(this.imgArray[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },

    //更改或添加
    fileUpdate() {
      this.$refs.file.setAttribute('type', 'file')
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        let imgArr = []
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          // this.imgArray.push(obj);
          imgArr.push(obj)
        }
        this.$refs.file.setAttribute('type', 'text')
        Dialog.open({
          title: '上传图片',
          component: UserImgUpload,
          data: {
            imgArray: imgArr,
            id: this.recheckForm.id,
            width: '800px',
            from: 4
          },
          confirm: (result) => {

            this.getVisitImg()
          }
        })
      }
    },

    userImgList() {
      let _title = '';
      _title = '回访图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: this.imgArray,
          id: this.recheckForm.id,
          width: 908,
          from: 4,
          hideBtn: (this.operateState & 2)  == 2 || this.recheckForm.recheckState == 5 || this.recheckForm.recheckState == 6
        },
        confirm: (result) => {
          this.getVisitImg()
        }
      })
    },


    getVisitImg() {
      getFormData(listVisitImg,{id: this.recheckForm.id}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.imgArray = []
          this.imgArray = this.imgArray.concat(data.data)
          // this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },



    cancel() {
      this.$emit("close");
    },

    summit() {
      if(this.recheckForm.recheckState != 4 && this.recheckForm.recheckState != 5 && this.recheckForm.recheckState != 6) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择复核状态',
          type: 'warning'
        });
        return false
      }
      let arr = []
      arr.push(this.recheckForm.id)
      let param = {}
      param['idArr'] = arr
      param['recheckState'] = this.recheckForm.recheckState;
      if(this.recheckForm.recheckState == 4) {
        param['recheckRemark'] = this.recheckForm.recheckRemark;
      }
      postFormData(updateVisitRecheckState, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


  },
  mounted() {
    // this.getVisitImg()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ccc;
  font-size: 12px;
  cursor: pointer;
  /*float: left;*/
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
  cursor: pointer;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
